import { useEffect, useRef, useInsertionEffect } from "react";

export const useEventListener = <T extends keyof DocumentEventMap>(
  eventType: T,
  callback: (ev: DocumentEventMap[T]) => unknown
): void => {
  // Creates a performant stable callback reference without requiring memoization
  const callbackRef = useRef(callback);
  useInsertionEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    if (document === null) {
      return;
    }
    const handler: (e: DocumentEventMap[T]) => unknown = (
      e: DocumentEventMap[T]
    ) => callbackRef.current(e);

    document.addEventListener(eventType, handler, { passive: true });

    return () => document.removeEventListener(eventType, handler);
  }, [eventType]);
};
